<template>
  <PageContainer>
    <SectionContainer class="pt-2">
      <h1>Entourage</h1>
      <img src="https://withjoy.com/media/7336a473-dcfa-4c51-91ce-66b075a817fa/1bf670f0-ec27-11ef-a60a-2b4f95224bc2-Bridal%20Party.png">
    </SectionContainer>
  </PageContainer>
</template>

<script>
import PageContainer from '@/pages/PageContainer'
import SectionContainer from '@/pages/SectionContainer'

export default {
  name: 'EntouragePage',
  components: {
    PageContainer,
    SectionContainer,
  },
  data() {
    return {
    }
  },
  beforeMount() {
  },
  methods: {
  },
}
</script>